<div class="inbox-chat">
  <glxy-loading-spinner *ngIf="loading()" class="show-loading"></glxy-loading-spinner>
  <inbox-messages
    [messages]="messages$ | async"
    [conversation]="(currentConversationDetail$ | async)?.conversation"
  ></inbox-messages>
  <inbox-message-text
    #inboxTextComponent
    (sendMessage)="sendMessage($event)"
    [conversationDetail]="currentConversationDetail$ | async"
    [availableChannels]="availableChannels"
    [isImpersonating]="isImpersonating$ | async"
  ></inbox-message-text>
</div>
